import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { PrivateRadioOption } from './PrivateRadioOption';
import { PublicRadioOption } from './PublicRadioOption';
import { TeamRadioOption } from './TeamRadioOption';
import { getCheckedOptionFromView } from '../../getCheckedOptionFromView';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TaskViewSharingEditor = ({
  originalView,
  viewUpdates,
  setViewUpdates
}) => {
  const [checkedOption, setCheckedOption] = useState(getCheckedOptionFromView(viewUpdates));
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "viewsManagement.modals.manageSharing.label"
    }),
    children: /*#__PURE__*/_jsxs(ToggleGroup, {
      name: "view-sharing-options",
      children: [/*#__PURE__*/_jsx(PrivateRadioOption, {
        checkedOption: checkedOption,
        setCheckedOption: setCheckedOption,
        setViewUpdates: setViewUpdates,
        viewUpdates: viewUpdates
      }), /*#__PURE__*/_jsx(TeamRadioOption, {
        checkedOption: checkedOption,
        originalView: originalView,
        setCheckedOption: setCheckedOption,
        setViewUpdates: setViewUpdates,
        viewUpdates: viewUpdates
      }), /*#__PURE__*/_jsx(PublicRadioOption, {
        checkedOption: checkedOption,
        setCheckedOption: setCheckedOption,
        setViewUpdates: setViewUpdates,
        viewUpdates: viewUpdates
      })]
    })
  });
};